import DOMPurify from "dompurify";

export const sanitizeHtml = (html: string): string => {
  try {
    return DOMPurify.sanitize(html, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target", "rel"],
    });
  } catch (e) {
    console.warn("Sanitization failed", e);
    return "";
  }
};
